import { gql } from '@apollo/client'

export const CHANGE_BUSINESS_SITE = gql`
  mutation ChangeBusinessSite($id: UUID!, $input: ChangeBusinessSiteInput!) {
    changeBusinessSite(id: $id, input: $input)
  }
`

export const CREATE_BUSINESS_SITE_CONTACTS = gql`
  mutation CreateBusinessSiteContacts($id: UUID!, $input: CreateBusinessSiteContactsInput!) {
    createBusinessSiteContacts(id: $id, input: $input)
  }
`

export const CHANGE_BUSINESS_SITE_CONTACTS = gql`
  mutation ChangeBusinessSiteContacts($id: UUID!, $input: ChangeBusinessSiteContactsInput!) {
    changeBusinessSiteContacts(id: $id, input: $input)
  }
`

export const DELETE_BUSINESS_SITE_CONTACTS = gql`
  mutation DeleteBusinessSiteContacts($id: UUID!, $input: DeleteBusinessSiteContactsInput!) {
    deleteBusinessSiteContacts(id: $id, input: $input)
  }
`

export const ACTIVATE_BUSINESS_SITE = gql`
  mutation ActivateBusinessSite($id: UUID!) {
    activateBusinessSite(id: $id)
  }
`
